declare const DEMO_USERNAME: string;
declare const IS_IMPERSONATED_SESSION: boolean;

const hostname = window.location.hostname;
const pathname = window.location.pathname;

export const IS_ADMIN =
  (hostname === "admin.buttondown.com" ||
    hostname === "127.0.0.1" ||
    hostname === "localhost" ||
    hostname.endsWith(".bd")) &&
  !pathname.includes("/vue-storybook/");

export const IS_DEMO =
  !import.meta.env.VITEST &&
  typeof DEMO_USERNAME !== "undefined" &&
  DEMO_USERNAME !== "" &&
  !IS_ADMIN;

export const IS_IMPERSONATED =
  typeof IS_IMPERSONATED_SESSION !== "undefined" && IS_IMPERSONATED_SESSION;

// Set when an operator is viewing the app as another user via
// `/admin/impersonate/<username>/...` (see `buttondown/views/admin.py`). The
// base doubles as the router's history base so every route stays under the
// prefix.
export const IMPERSONATION_BASE = pathname.match(
  /^\/admin\/impersonate\/[^/]+/
)?.[0];
export const IMPERSONATION_USERNAME = IMPERSONATION_BASE?.split("/").at(-1);
